import React from "react";
import {styled, Icon, NavLink, Button, theme} from "@reside/ui";
import {RoleNameEnum} from "../../utils/types/common";
import {SSOBadge} from "../list-table/SSOBadge";
import {ButtonLink} from "../button-link";
import {AdminRoles} from "../admin-roles";
import {CreateOrganizationRequest} from "../../utils/types/organization";
import {Space} from "../space";
import {BASE_URL} from "./organizationFormConstants";

const AddIcon = styled(Icon)`
  padding-right: 10px;
`;

type Props = Readonly<{
  initialValues?: CreateOrganizationRequest;
  onStatusChange?: () => Promise<void> | void;
  status?: string;
  hasSsoConfig?: {ssoEntryExists: boolean; ssoIsEnabled: boolean};
  isResideAdmin: boolean;
}>;

export const OrganizationStatusButtons = ({
  initialValues,
  onStatusChange,
  status,
  hasSsoConfig,
  isResideAdmin,
}: Props) => {
  if (!initialValues || !onStatusChange) {
    return null;
  }

  const title = status === "ACTIVE" ? "Deactivate" : "Activate";
  const color = status === "ACTIVE" ? "danger" : "success";

  return (
    <Space>
      <AdminRoles roles={[RoleNameEnum.ORGANIZATION_ADMIN]}>
        <NavLink
          style={{marginLeft: theme.space[0]}}
          to={
            hasSsoConfig?.ssoEntryExists
              ? `${BASE_URL}/${initialValues.id}/sso-configuration`
              : `${BASE_URL}/${initialValues.id}/sso-configuration/create`
          }
        >
          <SSOBadge
            label={
              hasSsoConfig?.ssoEntryExists
                ? "SSO configured"
                : "SSO not configured"
            }
          />
        </NavLink>
      </AdminRoles>

      <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
        <SSOBadge
          label={
            hasSsoConfig?.ssoEntryExists
              ? "SSO configured"
              : "SSO not configured"
          }
        />
      </AdminRoles>

      <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
        {status === "ACTIVE" && (
          <ButtonLink
            to={`${BASE_URL}/${initialValues.id}/create-facility`}
            color="primary"
          >
            <AddIcon name="add" size={14} />
            New Facility
          </ButtonLink>
        )}
        {isResideAdmin && !hasSsoConfig?.ssoIsEnabled && (
          <ButtonLink
            to={`${BASE_URL}/${initialValues.id}/manage-users`}
            color="success"
          >
            Manage Users
          </ButtonLink>
        )}
        <Button onClick={onStatusChange} color={color} outline>
          {title}
        </Button>
      </AdminRoles>
    </Space>
  );
};
